import { Grid, Button, Typography, Container, Toolbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import { AppColors } from "../../../util/AppColors";
import Checkbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import SearchRow from "../../../components/SearchRow/SearchRow";
import Select from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import Header from "../../../layouts/header";
import {
  addClinic,
  getClinics,
  updateClinic,
} from "../../../redux/reducers/clinicSlice";
import { ErrorStrings } from "../../../util/ErrorString";
import { EmailRegex } from "../../../util/Validations";
import { clinicFilterList } from "../../../util/arrayList";
import generatePass from "../../../util/randomPassword";
import "./Clinic.css";
import { locationDropList } from "../../../util/dropList";

const tableHeaders = ["id", "clinicName", "location", "noOfVets", "status", "action"];

const nameExpan = {
  hospitalname: "Clinic Name",
  location: "Location",
  administartorContact: "Administartor Contact",
  contactNumber: "Contact Number",
  email: "Email",
  password: "Password",
  // conType: "Consultation Type",
};

const initialValues = {
  hospitalname: "",
  location: "",
  administartorContact: "",
  contactNumber: "",
  email: "",
  password: "",
  // conType: [],
};

const initialError = {
  hospitalname: false,
  location: false,
  administartorContact: false,
  contactNumber: false,
  email: false,
  password: false,
  // conType: false,
};

const initialHelp = {
  hospitalname: "",
  location: "",
  administartorContact: "",
  contactNumber: "",
  email: "",
  password: "",
  // conType: "",
};

const initialFile = { file: null, imagePreviewUrl: "" };

const Clinic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hospitals = useSelector((state) => state?.clinic?.hospitals);
  // console.log("hospital------>>",hospitals)
  //   const hospitals =
  //   {
  //     "totalRecords": 2,
  //     "hospitals": [
  //         {
  //             "id": 3,
  //             "name": "cmc",
  //             "location": "chennai",
  //             "vets": 0,
  //             "status": "Y",
  //             "role": "ROLE_CLINIC"
  //         },
  //         {
  //             "id": 5,
  //             "name": "cmc",
  //             "location": "chennai",
  //             "vets": 0,
  //             "status": "Y",
  //             "role": "ROLE_CLINIC"
  //         }
  //     ]
  // }
  const locations = useSelector((state) => state.clinic.locations);
  const [isTableView, setTableView] = useState(true);
  const [isCardView, setCardView] = useState(false);
  const [tableHospitals, setTableHospitals] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [clinicValues, setClinicValues] = useState(initialValues);
  const [clinicErrors, setClinicErrors] = useState(initialError);
  const [clinicHelps, setClinicHelps] = useState(initialHelp);
  const [showPassword, setShowPassword] = useState(false);
  const [isAutoGenPass, setAutoGenPass] = useState(false);
  const [fileUploadUrl, setFileUploadUrl] = useState(initialFile);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [dropLocations, setDropLocations] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchTypeValue, setSearchTypeValue] = useState("name");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  // const defaultUrl = `?limit=${rowsPerPage}&skip=0&type=${searchTypeValue}`;
  const defaultUrl = `?page=${page}&itemSize=${rowsPerPage}`;

  useEffect(() => {
    dispatch(getClinics(defaultUrl));
  }, []);

  useEffect(() => {
    if (hospitals?.hospitals?.length > 0) {
      getAllHospitalList(hospitals?.hospitals);
    }
    if (locations?.length > 0) getAllLocationList(locations);
  }, [hospitals, locations]);



  const getAllLocationList = (locationList) => {
    const reqLocations =
      locationList?.length > 0
        ? locationList?.map((location) => {
            return { ...location, value: location?._id };
          })
        : [];
    setDropLocations(reqLocations);
  };

  const getAllHospitalList = (hospitalList) => {
    const reqHospitals =
      hospitalList?.length > 0
        ? hospitalList?.map((hos, i) => {
          console.log("hos------>>",hos);
            // Determine status - status field is "Y" (Active) or "N" (Inactive)
            // Also check for trial status if available (subscriptionType === "Trial" or trial field)
            const statusValue = hos?.status;
            const isTrial = hos?.subscriptionType?.toLowerCase() === "trial";
            const status = isTrial 
              ? "Trial" 
              : statusValue === "Y" 
              ? "Active" 
              : statusValue === "N" 
              ? "Inactive" 
              : "Inactive"; // Default to Inactive if status is not Y or N
            
            // Get expiration dates if available
            const expirationDate = hos?.expirationDate || hos?.expDate;
            const expiredDate = hos?.expiredDate;
            
            // Determine first button text and handler based on status
            // Based on UI: Active -> "Reactivate", Inactive -> "Suspend", Trial -> "Extend Trial"
            let firstButtonText = "Suspend";
            let firstButtonHandler = () => handleSuspend(hos);
            
            if (status === "Active") {
              firstButtonText = "Reactivate";
              firstButtonHandler = () => handleReactivate(hos);
            } else if (status === "Trial") {
              firstButtonText = "Extend Trial";
              firstButtonHandler = () => handleExtendTrial(hos);
            } else if (status === "Inactive") {
              firstButtonText = "Suspend";
              firstButtonHandler = () => handleSuspend(hos);
            }

            // Status button styling based on status
            let statusButtonStyle = {};
            if (status === "Active") {
              statusButtonStyle = {
                backgroundColor: "#10C200", // Green color for Active
                color: AppColors.white,
                borderRadius: "4px",
                padding: "4px 12px",
                fontSize: "12px",
                fontWeight: "600",
                textTransform: "capitalize",
                minWidth: "80px",
                height: "28px",
                boxShadow: "none",
                opacity: 1, // Ensure full opacity even when disabled
                "&.Mui-disabled": {
                  backgroundColor: "#10C200", // Keep green color when disabled
                  color: AppColors.white,
                  opacity: 1,
                },
                "&:hover": {
                  backgroundColor: "#069914",
                },
              };
            } else if (status === "Inactive") {
              statusButtonStyle = {
                backgroundColor: "#FF6B35" || "#F74444", // Orange-red color
                color: AppColors.white,
                borderRadius: "4px",
                padding: "4px 12px",
                fontSize: "12px",
                fontWeight: "600",
                textTransform: "capitalize",
                minWidth: "80px",
                height: "28px",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#E55A2B",
                },
              };
            } else if (status === "Trial") {
              statusButtonStyle = {
                backgroundColor: "#4FC3F7" || AppColors.lightBlue, // Light blue color
                color: AppColors.white,
                borderRadius: "4px",
                padding: "4px 12px",
                fontSize: "12px",
                fontWeight: "600",
                textTransform: "capitalize",
                minWidth: "80px",
                height: "28px",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#29B6F6",
                },
              };
            }

            // Format expiration date (format: DD-MMM-YY)
            const formatDate = (dateString) => {
              if (!dateString) return null;
              try {
                const date = new Date(dateString);
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const day = date.getDate().toString().padStart(2, "0");
                const month = months[date.getMonth()];
                const year = date.getFullYear().toString().slice(-2);
                return `${day}-${month}-${year}`;
              } catch (e) {
                return null;
              }
            };

            const expDateText = expirationDate 
              ? `Exp. on ${formatDate(expirationDate)}`
              : expiredDate 
              ? `Expired on ${formatDate(expiredDate)}`
              : null;

            return {
              ...hos,
              id: hos?.id,
              // id:
              //   hospitals?.totalRecords > rowsPerPage
              //     ? (page - 1) * rowsPerPage + (i + 1)
              //     : i + 1,
              clinicName: hos?.name,
              location: hos?.location,
              noOfVets: hos?.vets,
              status: (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                  <Button
                    variant="contained"
                    disabled
                    sx={statusButtonStyle}
                  >
                    {status}
                  </Button>
                  {expDateText && (
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: AppColors.gray3 || "#828282",
                        fontWeight: "400",
                        marginTop: "-2px",
                      }}
                    >
                      {expDateText}
                    </Typography>
                  )}
                </div>
              ),
              action: (
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <CustomButton
                    text={firstButtonText}
                    onClick={firstButtonHandler}
                    smallBtn
                    style={{ minWidth: "100px" }}
                  />
                  <CustomButton
                    text="Login"
                    onClick={() => handleLogin(hos)}
                    smallBtn
                    style={{ minWidth: "80px" }}
                  />
                </div>
              ),
            };
          })
        : [];
    setTableHospitals(reqHospitals);
  };

  const modelOpen = () => {
    handleReset();
    setModalVisible(!modalVisible);
  };

  const handleCardTableView = () => {
    setTableView(!isTableView);
    setCardView(!isCardView);
  };

  const emailValidation = (value) => {
    if (value === "") {
      setClinicErrors({ ...clinicErrors, email: true });
      setClinicHelps({ ...clinicHelps, email: ErrorStrings.emptyEmail });
    }
    if (value !== "") {
      if (!EmailRegex.test(value)) {
        setClinicErrors({ ...clinicErrors, email: true });
        setClinicHelps({ ...clinicHelps, email: ErrorStrings.inValidEmail });
      } else {
        setClinicErrors({ ...clinicErrors, email: false });
        setClinicHelps({ ...clinicHelps, email: "" });
      }
    }
  };

  const passValidation = (value) => {
    if (value === "") {
      setClinicErrors({ ...clinicErrors, password: true });
      setClinicHelps({ ...clinicHelps, password: ErrorStrings.emptyPass });
      return;
    }
    if (value.length < 6) {
      setClinicErrors({ ...clinicErrors, password: true });
      setClinicHelps({ ...clinicHelps, password: ErrorStrings.inValidPass });
      return;
    }
    setClinicErrors({ ...clinicErrors, password: false });
    setClinicHelps({ ...clinicHelps, password: "" });
  };

  const handleChange = (e) => {
    setClinicValues({ ...clinicValues, [e.target.name]: e.target.value });
    if (e.target.name === "email") return emailValidation(e.target.value);
    if (e.target.name === "password") return passValidation(e.target.value);

    if (e.target.value === "") {
      setClinicErrors({ ...clinicErrors, [e.target.name]: true });
      setClinicHelps({
        ...clinicHelps,
        [e.target.name]: `${nameExpan?.[e.target.name]} Required Field`,
      });
    }
    if (e.target.value !== "") {
      setClinicErrors({ ...clinicErrors, [e.target.name]: false });
      setClinicHelps({ ...clinicHelps, [e.target.name]: "" });
    }
  };

  const onUploadFile = (e) => {
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setFileUploadUrl({
        file: e.target.files[0],
        imagePreviewUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleValidation = () => {
    const errorList = [];
    const woErrorList = [];
    Object.keys(clinicValues).forEach(function (key, index) {
      if (key === "email") {
        if (clinicValues?.[key] === "") return errorList?.push(key);
        if (!EmailRegex.test(clinicValues?.[key])) {
          return errorList?.push(key);
        } else woErrorList.push(key);
      } else if (key === "password") {
        if (selectedHospital?._id) return;
        if (clinicValues?.[key] === "") return errorList?.push(key);
        if (clinicValues?.[key]?.length < 6) {
          return errorList?.push(key);
        } else woErrorList.push(key);
      } else {
        if (clinicValues?.[key]?.length === 0 || clinicValues?.[key] === "") {
          return errorList?.push(key);
        }
        woErrorList.push(key);
      }
    });
    let errorObj = {};
    let errorHelperObj = {};
    let correctObj = {};
    let helperObj = {};
    //set Error
    if (errorList?.length > 0) {
      errorList?.forEach((key) => {
        errorObj = { ...errorObj, [key]: true };
        const value = clinicValues?.[key];
        if (key === "email") {
          if (value === "") {
            errorHelperObj = {
              ...errorHelperObj,
              [key]: ErrorStrings.emptyEmail,
            };
            return;
          }
          if (!EmailRegex.test(value)) {
            errorHelperObj = {
              ...errorHelperObj,
              [key]: ErrorStrings.inValidEmail,
            };
            return;
          }
        }
        if (key === "password") {
          if (value === "") {
            errorHelperObj = {
              ...errorHelperObj,
              [key]: ErrorStrings.emptyPass,
            };
            return;
          }
          if (value < 6) {
            errorHelperObj = {
              ...errorHelperObj,
              [key]: ErrorStrings.inValidPass,
            };
          }
        }
        errorHelperObj = {
          ...errorHelperObj,
          [key]: `${nameExpan?.[key]} Required Field`,
        };
      });
    }
    //remove Error
    if (woErrorList?.length > 0) {
      woErrorList?.forEach((key) => {
        correctObj = { ...correctObj, [key]: false };
        helperObj = { ...helperObj, [key]: "" };
      });
    }
    setClinicErrors({ ...clinicErrors, ...correctObj, ...errorObj });
    setClinicHelps({ ...clinicHelps, ...helperObj, ...errorHelperObj });
    return { errorList, woErrorList };
  };

  const handleSubmit = async () => {
    // const validation = handleValidation();
    // if (validation?.errorList?.length > 0) return;
    
    const isEditMode = selectedHospital?._id;
    
    // Create FormData for clinic registration
    const form = new FormData();
    
    // Required fields for clinic/register endpoint
    form.append("name", clinicValues?.hospitalname || "");
    form.append("location", clinicValues?.location || "");
    form.append("adminContact", clinicValues?.administartorContact || "");
    form.append("contactNumber", clinicValues?.contactNumber || "");
    form.append("email", clinicValues?.email || "");
    
    // Password is required for new clinic registration
    if (!isEditMode) {
      form.append("password", clinicValues?.password || "");
    }
    
    // Image is optional
    if (fileUploadUrl?.file) {
      form.append("hosImage", fileUploadUrl?.file);
    }
    
    let apiSuccess;
    if (isEditMode) {
      // Update existing clinic
      apiSuccess = await dispatch(
        updateClinic({ form, clinicId: selectedHospital?._id })
      );
    } else {
      // Create new clinic using clinic/register endpoint
      apiSuccess = await dispatch(addClinic(form));
    }
    
    if (apiSuccess?.payload) {
      setTableHospitals([]);
      setPage(1);
      dispatch(getClinics(defaultUrl));
      setModalVisible(false);
      handleReset();
    }
  };

  const handleReset = () => {
    setPage(1);
    setSearchTypeValue("name");
    setClinicValues(initialValues);
    setClinicErrors(initialError);
    setClinicHelps(initialHelp);
    setFileUploadUrl(initialFile);
    setAutoGenPass(false);
    setSelectedHospital(null);
  };

  const handleEdit = (hospital) => {
    navigate(`/clinic-details/${hospital?._id}`);
    // setSelectedHospital(hospital);
  };

  const handleSuspend = (hospital) => {
    console.log("Suspend clinic:", hospital);
    // TODO: Implement suspend functionality
  };

  const handleReactivate = (hospital) => {
    console.log("Reactivate clinic:", hospital);
    // TODO: Implement reactivate functionality
  };

  const handleExtendTrial = (hospital) => {
    console.log("Extend trial for clinic:", hospital);
    // TODO: Implement extend trial functionality
  };

  const handleLogin = (hospital) => {
    console.log("Login as clinic:", hospital);
    // TODO: Implement login functionality
    // This might involve setting clinic context and navigating to clinic dashboard
  };

  // const handleMultiSelect = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setClinicValues({
  //     ...clinicValues,
  //     conType: typeof value === "string" ? value.split(",") : value,
  //   });
  //   setClinicErrors({
  //     ...clinicErrors,
  //     conType: value?.length > 0 ? false : true,
  //   });
  //   setClinicHelps({
  //     ...clinicHelps,
  //     conType:
  //       value?.length > 0 ? "" : `${nameExpan?.["conType"]} Required Field`,
  //   });
  // };

  const handleSelect = (e, key) => {
    setClinicValues({ ...clinicValues, [key]: e.target.value });
  };

  const handleSearch = () => {
    setPage(1);
    const url = `?limit=${rowsPerPage}&skip=0${
      searchValue?.length > 0 ? `&search=${searchValue}` : ""
    }${searchTypeValue ? `&type=${searchTypeValue}` : ""}`;
    setTableHospitals([]);
    dispatch(getClinics(url));
  };

  const handleResetBtn = () => {
    setPage(1);
    setSearchTypeValue("name");
    setSearchValue("");
    setTableHospitals([]);
    dispatch(getClinics(defaultUrl));
  };

  const importClinic = () => {
    console.log("import clinic");
  };

  const downloadClinic = () => {
    console.log("download clinic");
  };

  const handleChangePage = (e, selectedPage) => {
    const reqSkip = (selectedPage - 1) * rowsPerPage;
    setPage(selectedPage);

    const url = `?page=${selectedPage}&itemSize=${rowsPerPage}`;
    dispatch(getClinics(url));
  };

  const handleAutoGenPassword = () => {
    setAutoGenPass(!isAutoGenPass);
    if (!isAutoGenPass) {
      const pass = generatePass();
      setClinicValues({ ...clinicValues, password: pass });
    } else {
      setClinicValues({ ...clinicValues, password: "" });
    }
  };

  return (
    <div style={{ paddingBottom: 0, marginBottom: 0 }}>
      {/* <Header name="Vetinstant" /> */}
      <TopBar>
        <Container maxWidth="xl" sx={{ paddingBottom: 0, marginBottom: 0, paddingX: 2 }}>
          <Toolbar variant="regular" sx={{ paddingBottom: 0, marginBottom: 0, minHeight: "60px !important" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <Typography className="font-bold fs18" sx={{ marginRight: 2 }}>
                    Clinics
                  </Typography>
                  <div style={{ display: "flex", gap: "10px", marginLeft: "auto" }}>
                    <CustomButton
                      text="Create Clinic"
                      onClick={modelOpen}
                      smallBtn
                    />
                    {/* <CustomButton
                      text="Import Clinics"
                      onClick={importClinic}
                      smallBtn
                      grayBtn
                    />
                    <CustomButton
                      text="Download Reports"
                      onClick={downloadClinic}
                      smallBtn
                      grayBtn
                    /> */}
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
        </Container>
      </TopBar>
      {/* <SearchRow
        leftBtnTxt="Reset"
        rightBtnTxt="Search"
        tableView={isTableView}
        cardView={isCardView}
        onClickCardView={handleCardTableView}
        onClickTableView={handleCardTableView}
        onSerchChange={(e) => setSearchValue(e.target.value)}
        searchValue={searchValue}
        searchTypeList={clinicFilterList}
        searchTypeValue={searchTypeValue}
        handleChangeSearchValue={(e) => setSearchTypeValue(e.target.value)}
        onClickBlueBtn={handleSearch}
        onClickRedBtn={handleResetBtn}
      /> */}
      <div style={{ paddingBottom: 0, marginBottom: 0, padding: "0 15px" }}>
        {isTableView ? (
          <Table
            columns={tableHeaders}
            datas={tableHospitals}
            onClickEditBtn={handleEdit}
            page={page}
            rowsPerPage={2}
            totalRecords={hospitals?.totalRecords}
            handleChangePage={handleChangePage}
            isCustomTableSty={true}
            tableStyle={{ paddingBottom: 0, marginBottom: 0 }}
          />
        ) : null}
      </div>
      <CustomModal
        open={modalVisible}
        onClose={modelOpen}
        header={`${selectedHospital?._id ? "Edit" : "Add"} Clinic`}
        headerCenter
        modal
        modalWidth={50}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomUpload
              uploadText={"Tab to add a profile picture"}
              onUploadFile={onUploadFile}
              value={fileUploadUrl?.imagePreviewUrl}
              center
              imageHeight={75}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label={nameExpan?.["hospitalname"]}
              placeholder={nameExpan?.["hospitalname"]}
              name="hospitalname"
              fullWidth
              handleChange={handleChange}
              value={clinicValues?.hospitalname}
              helperText={clinicHelps?.hospitalname}
              error={clinicErrors?.hospitalname}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Select
              list={locationDropList}
              value={clinicValues?.location}
              handleChange={(e) => handleSelect(e, "location")}
              name="location"
              label={nameExpan?.["location"]}
              select
              error={clinicErrors.location}
              helperText={clinicHelps?.location}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label={nameExpan?.["administartorContact"]}
              placeholder={nameExpan?.["administartorContact"]}
              name="administartorContact"
              fullWidth
              handleChange={handleChange}
              value={clinicValues?.administartorContact}
              helperText={clinicHelps?.administartorContact}
              error={clinicErrors?.administartorContact}
              // disabled={selectedHospital?._id ? true : false}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label={nameExpan?.["contactNumber"]}
              placeholder={nameExpan?.["contactNumber"]}
              name="contactNumber"
              fullWidth
              handleChange={handleChange}
              value={clinicValues?.contactNumber}
              helperText={clinicHelps?.contactNumber}
              error={clinicErrors?.contactNumber}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label={nameExpan?.["email"]}
              placeholder={nameExpan?.["email"]}
              name="email"
              fullWidth
              handleChange={handleChange}
              value={clinicValues?.email}
              helperText={clinicHelps?.email}
              error={clinicErrors?.email}
              disabled={selectedHospital?._id ? true : false}
            />
          </Grid>
          {!selectedHospital?._id ? (
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label={nameExpan?.["password"]}
                placeholder={nameExpan?.["password"]}
                name="password"
                password
                fullWidth
                value={clinicValues?.password}
                handleChange={handleChange}
                showPassword={showPassword}
                handleClickShowPassword={() => setShowPassword(!showPassword)}
                helperText={clinicHelps?.password}
                error={clinicErrors?.password}
              />
            </Grid>
          ) : null}
          {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Select
              list={typeList}
              value={clinicValues?.conType}
              handleChange={handleMultiSelect}
              multiSelectTag
              label={nameExpan?.["conType"]}
              error={clinicErrors?.conType}
              helperText={clinicHelps?.conType}
            />
          </Grid> */}
          {!selectedHospital?._id ? (
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Checkbox
                label="Auto-Generate Password"
                checked={isAutoGenPass}
                onChange={handleAutoGenPassword}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="clinic-mod-btn-pos">
              <div className="mr10">
                <CustomButton text="Reset" onClick={handleReset} grayBtn />
              </div>
              <div className="ml10">
                <CustomButton
                  text={selectedHospital?._id ? "Update" : "Register"}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default Clinic;
